export const NAME = 'Organizace';
export const CRUMB_LABEL_KEY = 'edtOrganizace';
export { DMS_MODULE } from '../constants';

export enum TAB_NAMES {
	HLAVNIUDAJE = 'HlavniUdaje',
	NASTAVENI = 'Nastaveni',
	MENA = 'Mena',
	SKLADPNEU = 'SkladPneu',
	KALKULACE = 'Kalkulace',
	SILVERDAT = 'SilverDAT',
	FINSTAT = 'FinStat',
	AUDANEXT = 'AudaNext',
	TRIPOD = 'tripod',
}

export const TABS = {
	[TAB_NAMES.HLAVNIUDAJE]: { id: TAB_NAMES.HLAVNIUDAJE, labelKey: 'TabOrg0' },
	[TAB_NAMES.NASTAVENI]: { id: TAB_NAMES.NASTAVENI, labelKey: 'TabOrg1' },
	[TAB_NAMES.MENA]: { id: TAB_NAMES.MENA, labelKey: 'TabOrg2' },
	[TAB_NAMES.SKLADPNEU]: { id: TAB_NAMES.SKLADPNEU, labelKey: 'TabOrg4' },
	[TAB_NAMES.KALKULACE]: { id: TAB_NAMES.KALKULACE, labelKey: 'TabOrg5' },
	[TAB_NAMES.SILVERDAT]: { id: TAB_NAMES.SILVERDAT, labelKey: 'SilverDAT' },
	[TAB_NAMES.FINSTAT]: { id: TAB_NAMES.FINSTAT, labelKey: 'FinStat' },
	[TAB_NAMES.AUDANEXT]: { id: TAB_NAMES.AUDANEXT, labelKey: 'AudaNext' },
	[TAB_NAMES.TRIPOD]: { id: TAB_NAMES.TRIPOD, labelKey: 'Tripod' },
};
